import { setRecoil } from "recoil-nexus";
import { fnolQuestionSetStructureState } from "atoms/fnolQuestionSetState.atom";
import * as ApiLocations from "api-calls/ApiLocations";
import { apiGetAxios } from "api-calls/ApiCommands";
import { generateGuid } from "shared/Helpers";

export const getFnolQuestionSetFromId = async () => {
  const url = await ApiLocations.getFnolQuestionSet();
  const returnedFnolQuestionSet = await apiGetAxios(url);
  let fnolStructure = returnedFnolQuestionSet.fnol;

  const fnolQuestionSet = {
    id: returnedFnolQuestionSet.id,
    newQuestionSet: false,
    tempDocumentsId: generateGuid(),
    customerId: fnolStructure.customerId,
    fnolQuestionSetName: returnedFnolQuestionSet.name,
    fnolQuestionSetDescription: fnolStructure.fnolQuestionSetDescription,
    fnol: fnolStructure.fnol,
    createdByUserId: returnedFnolQuestionSet.CreatedByUserId,
  };

  setRecoil(fnolQuestionSetStructureState, fnolQuestionSet);
};
